module.exports = __webpack_public_path__ + "img/night-vision-equipment.926e5fc9.png";